// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1hy_w","imageUploader":"EGiftCard_imageUploader__1I-23"};